// src/js/components/Evaluation/Introduction.js
import React, { Component } from "react";
import { connect } from "react-redux";
import renderHTML from "react-render-html";

import { startClick } from "../../actions/index";

const mapStateToProps = state => {
    return {
        introduction: state.data.introduction,
        introclass: state.actionclasses.intro
    };
};

function mapDispatchToProps(dispatch) {
    return {
        startClick: payload => dispatch(startClick(payload))
    };
}

class ConnectedIntroduction extends Component {
    render() {
        return(
            <div>
                {/*<h1 className="evTitleH1">{renderHTML(this.props.introduction.title)}</h1>*/}
                {/*<div className="evContent">{renderHTML(this.props.introduction.content)}</div>*/}
                <div className={`evTitleContainer ${this.props.introclass}`}>
                    <h2>{renderHTML(this.props.introduction.subtitle)}</h2>
                    <div>{renderHTML(this.props.introduction.subcontent)}</div>
                    <div className="evStartButtonContainer">
                        <span className="evStartButton" onClick={(e) => this.props.startClick(null)}>Start your evaluation</span>
                    </div>
                </div>
            </div>
        )
    }
}

const Introduction = connect(mapStateToProps,mapDispatchToProps)(ConnectedIntroduction);

export default Introduction;